module Meevo.Components.Common {
  angular.module("meevo.components.common", []);
}